<div class="notes-container">
  <div class="notes-header">
    <div class="row">
      <div class="col-md-3">
        <input
          type="text"
          class="form-control"
          [(ngModel)]="searchText"
          (ngModelChange)="filterNotes()"
          placeholder="Search notes..."
          aria-label="Search notes"
        />
      </div>
      <div class="col-md-2">
        <select
          class="form-control"
          [(ngModel)]="filterStatus"
          (ngModelChange)="filterNotes()"
          aria-label="Filter by status"
        >
          <option value="">All Statuses</option>
          <option *ngFor="let status of noteStatuses" [value]="status">{{ status }}</option>
        </select>
      </div>
      <div class="col-md-2">
        <select
          class="form-control"
          [(ngModel)]="filterType"
          (ngModelChange)="filterNotes()"
          aria-label="Filter by note type"
        >
          <option value="">All Types</option>
          <option *ngFor="let type of noteTypes" [value]="type">{{ type }}</option>
        </select>
      </div>
      <div class="col-md-2">
        <input
          type="date"
          class="form-control"
          [(ngModel)]="filterDateFrom"
          (ngModelChange)="filterNotes()"
          placeholder="From date"
          title="From date"
          aria-label="Filter from date"
        />
      </div>
      <div class="col-md-2">
        <input
          type="date"
          class="form-control"
          [(ngModel)]="filterDateTo"
          (ngModelChange)="filterNotes()"
          placeholder="To date"
          title="To date"
          aria-label="Filter to date"
        />
      </div>
      <div class="col-md-1">
        <button *ngIf="canEdit" class="btn btn-primary" (click)="openAddModal()" title="Add Note">
          <i class="fa fa-plus"></i> Add
        </button>
      </div>
    </div>
  </div>

  <div class="notes-list" *ngIf="filteredNotes.length > 0">
    <div
      class="note-card"
      *ngFor="let note of filteredNotes"
      [ngClass]="{
        'note-open': note.status === 'Open',
        'note-inprogress': note.status === 'In Progress',
        'note-resolved': note.status === 'Resolved',
        'note-closed': note.status === 'Closed',
      }"
    >
      <!-- Status Badge -->
      <div class="note-status-badge" [ngClass]="getStatusClass(note.status)">
        {{ note.status }}
      </div>

      <!-- Note Content -->
      <div class="note-body">
        <div class="note-text" [innerHTML]="getHighlightedText(note.note)"></div>
      </div>

      <!-- Note Footer -->
      <div class="note-footer">
        <div class="note-footer-left">
          <span class="note-type-badge">{{ note.type }}</span>
        </div>
        <div class="note-footer-right">
          <div class="note-meta">
            <span class="note-author" *ngIf="note.createdByUserName">{{
              note.createdByUserName
            }}</span>
            <span class="note-date">{{ note.dateCreatedUtc | date: "MM/dd/yyyy HH:mm" }}</span>
          </div>
          <div class="note-actions" *ngIf="canEdit">
            <button
              class="btn-icon"
              title="Email to scheduling team drivers"
              (click)="openEmailTeamDrivers(note); $event.stopPropagation()"
            >
              <i class="fa fa-envelope"></i>
            </button>
            <button class="btn-icon" (click)="openEditModal(note)">
              <i class="fa fa-pencil"></i>
            </button>
            <button class="btn-icon btn-danger" (click)="deleteNote(note)">
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="no-notes" *ngIf="filteredNotes.length === 0">
    <i class="fa fa-sticky-note-o"></i>
    <p>No notes found</p>
  </div>
</div>

<!-- Add Note Modal -->
<p-dialog
  [(visible)]="showAddModal"
  [header]="'Add Note'"
  [modal]="true"
  [style]="{ width: '600px' }"
  [draggable]="false"
  [resizable]="false"
  [styleClass]="'add-note-dialog'"
>
  <div class="modal-body">
    <div class="form-group">
      <label>Type <span class="text-danger">*</span></label>
      <select class="form-control" [(ngModel)]="newNote.type" aria-label="Note type">
        <option value="">--Select Type--</option>
        <option *ngFor="let type of noteTypes" [value]="type">{{ type }}</option>
      </select>
    </div>

    <div class="form-group">
      <label>Status <span class="text-danger">*</span></label>
      <select class="form-control" [(ngModel)]="newNote.status" aria-label="Note status">
        <option *ngFor="let status of noteStatuses" [value]="status">{{ status }}</option>
      </select>
    </div>

    <div class="form-group">
      <label>Note <span class="text-danger">*</span></label>
      <textarea
        class="form-control"
        [(ngModel)]="newNote.note"
        rows="6"
        placeholder="Enter note text..."
        aria-label="Note text"
      ></textarea>
    </div>
  </div>

  <p-footer>
    <div class="button-group">
      <button class="btn btn-secondary" (click)="closeAddModal()">Cancel</button>
      <button class="btn btn-primary" (click)="saveNote()">Add Note</button>
    </div>
  </p-footer>
</p-dialog>

<!-- Edit Note Modal -->
<p-dialog
  [(visible)]="showEditModal"
  [header]="'Edit Note'"
  [modal]="true"
  [style]="{ width: '600px' }"
  [draggable]="false"
  [resizable]="false"
  [styleClass]="'add-note-dialog'"
>
  <div class="modal-body" *ngIf="editingNote">
    <div class="form-group">
      <label>Type <span class="text-danger">*</span></label>
      <select class="form-control" [(ngModel)]="editingNote.type" aria-label="Note type">
        <option value="">--Select Type--</option>
        <option *ngFor="let type of noteTypes" [value]="type">{{ type }}</option>
      </select>
    </div>

    <div class="form-group">
      <label>Status <span class="text-danger">*</span></label>
      <select class="form-control" [(ngModel)]="editingNote.status" aria-label="Note status">
        <option *ngFor="let status of noteStatuses" [value]="status">{{ status }}</option>
      </select>
    </div>

    <div class="form-group">
      <label>Note <span class="text-danger">*</span></label>
      <textarea
        class="form-control"
        [(ngModel)]="editingNote.note"
        rows="6"
        placeholder="Enter note text..."
        aria-label="Note text"
      ></textarea>
    </div>
  </div>

  <p-footer>
    <div class="button-group">
      <button class="btn btn-secondary" (click)="closeEditModal()">Cancel</button>
      <button class="btn btn-primary" (click)="updateNote()">Update Note</button>
    </div>
  </p-footer>
</p-dialog>

<!-- Team Driver Selection Modal -->
<p-dialog
  [(visible)]="showTeamSelectionDialog"
  [modal]="true"
  [style]="{ width: '650px', maxHeight: '90vh' }"
  header="Email Note to Scheduling Team Drivers"
  [closable]="true"
  (onHide)="cancelTeamSelection()"
>
  <div class="modal-body" style="max-height: 65vh; overflow-y: auto">
    <div *ngIf="schedulingTeamsLoading" class="text-center py-3">
      <i class="fa fa-spinner fa-spin"></i> Loading scheduling teams...
    </div>

    <div *ngIf="!schedulingTeamsLoading && schedulingTeamsForEmail.length === 0" class="text-muted">
      No scheduling teams found for this client.
    </div>

    <div
      *ngFor="let team of schedulingTeamsForEmail"
      class="mb-3"
      style="border-bottom: 1px solid #eee; padding-bottom: 10px"
    >
      <div class="d-flex align-items-center mb-1">
        <input
          type="checkbox"
          [id]="'cn-team-' + team.id"
          [checked]="selectedTeamIds.has(team.id)"
          (change)="toggleTeamSelection(team.id)"
          style="margin-right: 8px"
        />
        <label
          [for]="'cn-team-' + team.id"
          style="font-weight: 600; cursor: pointer; margin-bottom: 0"
        >
          {{ team.name }}
          <span style="font-weight: normal; color: #888" class="ml-1"
            >({{ (team.drivers || []).length }} drivers)</span
          >
        </label>
      </div>

      <div *ngIf="selectedTeamIds.has(team.id)" style="margin-left: 24px">
        <div *ngFor="let driver of team.drivers || []" class="d-flex align-items-center mb-1">
          <input
            type="checkbox"
            [id]="'cn-driver-' + (driver.driverId || driver.id)"
            [checked]="selectedDriverIds.has(driver.driverId || driver.id)"
            (change)="toggleDriverSelection(driver.driverId || driver.id)"
            [disabled]="!driver.email"
            style="margin-right: 8px"
          />
          <label
            [for]="'cn-driver-' + (driver.driverId || driver.id)"
            style="cursor: pointer; margin-bottom: 0"
            [style.color]="driver.email ? '' : '#aaa'"
          >
            {{ driver.name }} {{ driver.lastName }}
            <span *ngIf="driver.driverNo" style="color: #888" class="ml-1"
              >({{ driver.driverNo }})</span
            >
            <span *ngIf="driver.email" style="color: #888" class="ml-1">- {{ driver.email }}</span>
            <span *ngIf="!driver.email" style="color: #e6a817" class="ml-1">
              <i class="fa fa-exclamation-triangle"></i> No email
            </span>
          </label>
        </div>
      </div>
    </div>

    <div *ngIf="selectedDriversForEmail.length > 0" class="alert alert-info mt-3">
      <strong>{{ selectedDriversForEmail.length }}</strong> driver(s) will receive this email.
    </div>
  </div>
  <p-footer>
    <div class="button-group">
      <button class="btn btn-secondary" (click)="cancelTeamSelection()">Cancel</button>
      <button
        class="btn btn-primary"
        (click)="proceedWithTeamDriverEmail()"
        [disabled]="selectedDriversForEmail.length === 0"
      >
        <i class="fa fa-envelope"></i> Compose Email ({{ selectedDriversForEmail.length }})
      </button>
    </div>
  </p-footer>
</p-dialog>

<!-- Email Preview/Compose Modal -->
<p-dialog
  [(visible)]="showEmailPreview"
  [modal]="true"
  [style]="{ width: '650px' }"
  header="Compose Email"
  [closable]="false"
>
  <div class="modal-body">
    <div class="form-group">
      <label><strong>To:</strong></label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="emailPreview.to"
        [ngClass]="{ 'is-invalid': emailValidationError }"
        aria-label="Email to address"
      />
      <div *ngIf="emailValidationError" class="invalid-feedback d-block">
        {{ emailValidationError }}
      </div>
      <small class="form-text text-muted">Multiple addresses separated by semicolons</small>
    </div>

    <div class="form-group">
      <label><strong>CC:</strong></label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="emailPreview.ccEmails"
        placeholder="Optional - separate multiple with semicolons"
        aria-label="Email CC addresses"
      />
    </div>

    <div class="form-group">
      <label><strong>BCC:</strong></label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="emailPreview.bccEmails"
        placeholder="Optional - separate multiple with semicolons"
        aria-label="Email BCC addresses"
      />
    </div>

    <div class="form-group">
      <label><strong>Subject:</strong></label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="emailPreview.subject"
        aria-label="Email subject"
      />
    </div>

    <div class="form-group">
      <label><strong>Message:</strong></label>
      <textarea
        class="form-control"
        [(ngModel)]="emailPreview.body"
        rows="8"
        aria-label="Email message"
      ></textarea>
    </div>
  </div>
  <p-footer>
    <div class="button-group">
      <button class="btn btn-secondary" (click)="cancelEmailPreview()" [disabled]="emailSending">
        Cancel
      </button>
      <button
        class="btn btn-primary"
        (click)="confirmSendEmail()"
        [disabled]="emailSending || !emailPreview.to || !emailPreview.subject || !emailPreview.body || !emailFeaturesEnabled"
      >
        <i class="fa fa-spinner fa-spin" *ngIf="emailSending"></i>
        <i class="fa fa-paper-plane" *ngIf="!emailSending"></i>
        {{ emailSending ? "Sending..." : "Send Email" }}
      </button>
    </div>
  </p-footer>
</p-dialog>
